import { motion } from 'framer-motion';
import SellGoLogo from '@/components/SellGoLogo';

export default function SplashScreen() {
  return (
    <div
      className="fixed inset-0 flex flex-col items-center justify-center z-[9999]"
      style={{ background: 'linear-gradient(135deg, #1E3A5F 0%, #2563EB 100%)' }}
    >
      {/* Center content */}
      <div className="flex flex-col items-center gap-4">
        <motion.div
          initial={{ opacity: 0, scale: 0.7 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4, delay: 0.1, type: 'spring', damping: 14 }}
        >
          <SellGoLogo size={120} />
        </motion.div>

        <motion.div
          className="flex flex-col items-center gap-1"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35, delay: 0.3 }}
        >
          <span className="font-black text-4xl tracking-tight">
            <span className="text-white">Sell</span>
            <span style={{ color: '#10B981' }}>Go</span>
          </span>
        </motion.div>

        <motion.p
          className="text-white/70 text-sm font-medium"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3, delay: 0.5 }}
        >
          نظام مبيعات وتوزيع متكامل
        </motion.p>

        <motion.div
          className="mt-2 w-6 h-6 border-2 border-white/30 border-t-white rounded-full animate-spin"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.9 }}
        />
      </div>

      {/* Bottom attribution */}
      <motion.div
        className="absolute bottom-10 flex flex-col items-center gap-0.5"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3, delay: 0.7 }}
      >
        <span className="text-white/40" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>Powered by</span>
        <span className="font-black text-sm tracking-wider" style={{ color: '#D85A4A' }}>TECH SHARK</span>
        <span className="text-white/30" style={{ fontSize: '9px', letterSpacing: '2px' }}>FOR TECHNOLOGY</span>
      </motion.div>
    </div>
  );
}